import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VTT from './plugins/VTT';
import vuetify from "./plugins/vuetify";
import upperFirst from "lodash/upperFirst";
import camelCase from "lodash/camelCase";
import { Drag, Drop } from "vue-drag-drop";
import { VueMaskDirective } from "v-mask";
import commonAxios from "@/views/csr/common/axios";
import commonPusher from "@/views/csr/common/pusher";
import InfiniteLoading from "vue-infinite-loading";
import IdleVue from 'idle-vue';
import VueEasyLightbox from 'vue-easy-lightbox';

// detects when the user hasn't interacted with the app for a while
const eventsHub = new Vue()
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 1800000 // 15 minutes
})

Vue.directive("mask", VueMaskDirective);

commonAxios.init();
commonPusher.init();
Vue.use(InfiniteLoading);
Vue.use(VueEasyLightbox);


// AUTOLOADS BASE COMPONENTS
// first param: destination
// second param:Whether or not to look in subfolders
// third param:The regular expression used to match base component filenames
const requireComponent = require.context(
  "./components",
  false,
  /Base[A-Z]\w+\.(vue|js)$/
);

requireComponent.keys().forEach((fileName) => {
  // Get component config
  const componentConfig = requireComponent(fileName);
  // Get PascalCase name of component
  const componentName = upperFirst(
    // Gets the file name regardless of folder depth
    camelCase(
      fileName
        .split("/")
        .pop()
        .replace(/\.\w+$/, "")
    )
  );
  // Register component globally
  Vue.component(
    componentName,
    // Look for the component options on `.default`, which will
    // exist if the component was exported with `export default`,
    // otherwise fall back to module's root.
    componentConfig.default || componentConfig
  );
});

// adds a drag and drop component to the app
Vue.component("drag", Drag);
Vue.component("drop", Drop);

Vue.config.productionTip = false;

var vtt = new VTT();
vtt.connect();

Vue.prototype.$vtt = vtt;

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App),
  data() {
    return {
      textReplacementOnClick: null
    }
  }
}).$mount("#app");
